import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BasicComponent } from './basic/basic.component';
import { SidenavComponent } from './sidenav/sidenav.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';
import { LoginModule } from '../../core/modules/login/login.module';
import { LogoutComponent } from './logout/logout.component';
import { SignUpModule } from '../../core/modules/sign-up/sign-up.module';

@NgModule({
  declarations: [BasicComponent, SidenavComponent, LogoutComponent],
  imports: [CommonModule, MatSidenavModule, MatListModule, MatButtonModule, MatIconModule, RouterModule, LoginModule, SignUpModule],
})
export class AppLayoutModule { }
